<!--
* @Description:
* @Date: 2025-03-11 14:33:01
-->
<template>
  <div v-if="remarkContent" class="remark-hinit-custom">
    <div style="text-align: left;" class="remark-hinit-text-custom">
      备注：{{ remarkContent }}
    </div>
    <div>
      <i
        v-if="arrowsRight"
        @click="arrows"
        style="font-size: 20px;cursor: pointer;"
        class="el-icon-arrow-right"
      ></i>
      <i
        v-else
        @click="arrows"
        style="font-size: 20px;cursor: pointer;"
        class="el-icon-arrow-down"
      ></i>
    </div>
  </div>
</template>

<script>
import { queryProjectRemark } from '../api/index';
export default {
  components: {},
  data() {
    return {
      arrowsRight: false,
      remarkWidth: 0,
      remarkHeight: 0,
      initHeight: 20,
      remarkContent: ''
    };
  },
  computed: {},
  watch: {},
  methods: {
    arrows() {
      this.arrowsRight = !this.arrowsRight;
      this.styleChenge();
    },
    styleChenge() {
      let remarkHinitDom = document.querySelector('.remark-hinit-text-custom');
      if (this.arrowsRight) {
        remarkHinitDom.style.height = this.initHeight + 'px';
        remarkHinitDom.style.overflow = 'hidden';
        remarkHinitDom.style.width = this.remarkWidth - 5 + 'px';
        remarkHinitDom.style.textOverflow = 'ellipsis';
        remarkHinitDom.style.whiteSpace = 'nowrap';
        remarkHinitDom.style.wordBreak = 'break-all';
      } else {
        remarkHinitDom.style.height = '100%';
        remarkHinitDom.style.width = this.remarkWidth - 5 + 'px';
        remarkHinitDom.style.textOverflow = '';
        remarkHinitDom.style.whiteSpace = '';
        remarkHinitDom.style.wordBreak = '';
      }
    },
    getDom() {
      setTimeout(() => {
        let remarkHinitDom = document.querySelector('.remark-hinit-custom');
        if (remarkHinitDom) {
          this.remarkWidth = remarkHinitDom.getBoundingClientRect().width;
          this.remarkHeight = remarkHinitDom.getBoundingClientRect().height;
          this.styleChenge();
        } else {
          this.getDom();
        }
      });
    }
  },
  async created() {
    try {
      let res = await queryProjectRemark({
        projectId: this.$route.query.projectId || this.$route.query.id
      });
      this.remarkContent = res.data.data;
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    this.getDom();
  }
};
</script>
<style lang="scss" scoped>
.remark-hinit-custom {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px;
  background: #f59a23;
  color: #fff;
  border-radius: 5px;
}
//@import url(); 引入公共css类
</style>
